import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsScreensRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-screens',
	path: '/plugins/servlet/project-config/:projectKey/screens',
};
